import { useMemo } from 'react';

import { recruitmentStatusByCode, recruitmentStatusConfig } from 'entities';
import { useMultiState, useUrlStateV2 } from 'hooks';

import { getInitialDateSliceParams } from 'utils/date';
import { quickContext } from 'utils/react';

interface State {
  startDate: Date;
  endDate: Date;
}

const { useRecruitmentHome, withRecruitmentHomeContext } = quickContext('recruitmentHome', () => {
  const [{ status, recruitmentId }, setUrlState] = useUrlStateV2({
    status: {
      defaultValue: recruitmentStatusConfig.active.code,
      validate: (v) => !!recruitmentStatusByCode[v],
    },

    recruitmentId: '',
  });

  const { values, dispatch } = useMultiState<State>({
    ...getInitialDateSliceParams(),
  });

  return {
    data: useMemo(
      () => ({
        state: {
          ...values,
          status,
          recruitmentId: recruitmentId || null,
        },

        dispatch,

        changeStatus: (s: string) => setUrlState({ status: s }),

        changeRecruitmentFocus: (recruitmentId: string | null) => setUrlState({ recruitmentId }),
      }),
      [values, dispatch, status, setUrlState, recruitmentId],
    ),
  };
});

export { useRecruitmentHome, withRecruitmentHomeContext };
